import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import SummaryDiscussionHistoryPagesRepository from 'clients/db/SummaryDiscussionHistoryPagesRepository'
import SummaryDiscussionHistoryPage from 'model/SummaryDiscussionHistoryPage'
import { AppThunk } from '../../store'

interface SummaryDiscussionHistoryState {
  isLoading: boolean
  summaryDiscussionHistoryPages: SummaryDiscussionHistoryPage[]
}

const initialState: SummaryDiscussionHistoryState = {
  isLoading: false,
  summaryDiscussionHistoryPages: [],
}

function startLoading(state: SummaryDiscussionHistoryState) {
  state.isLoading = true
}

const SummaryDiscussionHistorySlice = createSlice({
  name: 'summaryDiscussionHistory',
  initialState,
  reducers: {
    fetchSummaryDiscussionHistoryStart: startLoading,
    fetchSummaryDiscussionHistoryFirstPageSuccess: (
      state,
      { payload }: PayloadAction<SummaryDiscussionHistoryPage>,
    ) => {
      state.isLoading = false
      state.summaryDiscussionHistoryPages = [payload]
    },
    fetchSummaryDiscussionHistoryPageSuccess: (
      state,
      { payload }: PayloadAction<SummaryDiscussionHistoryPage>,
    ) => {
      state.isLoading = false
      state.summaryDiscussionHistoryPages = [...state.summaryDiscussionHistoryPages, payload]
    },
  },
})
export const {
  fetchSummaryDiscussionHistoryStart,
  fetchSummaryDiscussionHistoryFirstPageSuccess,
  fetchSummaryDiscussionHistoryPageSuccess,
} = SummaryDiscussionHistorySlice.actions

export const fetchSummaryDiscussionHistoryPage = (
  selector: any,
  bookmark: string,
): AppThunk => async (dispatch) => {
  dispatch(fetchSummaryDiscussionHistoryStart())

  let summaryDiscussionHistoryPages
  summaryDiscussionHistoryPages = await SummaryDiscussionHistoryPagesRepository.searchSummaryDiscussionHistoryPage(
    selector,
    bookmark,
  )

  if (bookmark === '') {
    dispatch(fetchSummaryDiscussionHistoryFirstPageSuccess(summaryDiscussionHistoryPages))
  } else {
    dispatch(fetchSummaryDiscussionHistoryPageSuccess(summaryDiscussionHistoryPages))
  }
}

export default SummaryDiscussionHistorySlice.reducer
